import { Link } from "react-router-dom"
import clsx from "clsx"

type Props = {
  title: string
  backTo?: string
  children: React.ReactNode
  className?: string
}

export default function GameScreenLayout({
  title,
  backTo = "/play",
  children,
  className,
}: Props) {
  return (
    <div className={clsx("min-h-dvh bg-guardians-bg px-4 pb-8 pt-4", className)}>
      <div className="mx-auto flex max-w-app items-center gap-3">
        <Link
          to={backTo}
          className="text-sm text-guardians-accent hover:underline"
        >
          ← Назад
        </Link>
        <h1 className="text-lg font-semibold text-guardians-accent">{title}</h1>
      </div>
      <div className="mx-auto mt-4 max-w-app">{children}</div>
    </div>
  )
}
